<!-- @fallthroughAttributes true -->
<!-- @strictTemplates true -->

<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<{ class?: HTMLAttributes['class'] }>();

  // Custom data attribute for styling/selection purposes
  const dataAttrs = { 'data-slot': 'native-select-option' } as Record<string, string>;
</script>

<template>
  <option v-bind="dataAttrs" :class="cn('bg-popover text-popover-foreground', props.class)">
    <slot />
  </option>
</template>
